// An owl, modelled facing +X: a round upright body, a big disc-faced head with
// ear tufts and bright eyes. Ported 1:1 from age-of-mcp's classic owl.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.04, 0), color: "#7a6244",
      position: [0, 0.035, 0], scale: [1, 1.25, 0.95] },              // body
    { geometry: new THREE.IcosahedronGeometry(0.032, 0), color: "#8a7250",
      position: [0.012, 0.085, 0] },                                  // head
    { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#f4d35e",
      position: [0.03, 0.092, 0.014] },                              // eye
    { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#f4d35e",
      position: [0.03, 0.092, -0.014] },
    { geometry: new THREE.ConeGeometry(0.006, 0.014, 4), color: "#3a2c1c",
      position: [0.04, 0.09, 0], rotation: [0, 0, -Math.PI / 2] },     // beak
    { geometry: new THREE.ConeGeometry(0.01, 0.02, 4), color: "#6e573b",
      position: [0.0, 0.115, 0.02] },                                // ear tuft
    { geometry: new THREE.ConeGeometry(0.01, 0.02, 4), color: "#6e573b",
      position: [0.0, 0.115, -0.02] },
    // Folded wings down the sides.
    { geometry: new THREE.IcosahedronGeometry(0.018, 0), color: "#6e573b",
      position: [-0.01, 0.04, 0.035], scale: [1, 1.6, 0.4] },
    { geometry: new THREE.IcosahedronGeometry(0.018, 0), color: "#6e573b",
      position: [-0.01, 0.04, -0.035], scale: [1, 1.6, 0.4] },
  ];
}

export const owl = defineModel({
  id: "owl",
  batchId: "standard",
  name: "Owl",
  tags: ["creature","owl","low-poly","age-of-mcp","classic"],
  summary: "Low-poly owl.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.07,
  parts: () => partsFor(),
  animations: [],
});
